import { Button as e } from "./Button.js";
import t from "./ButtonIcon.module.js";
import { isValidElement as n } from "react";
import { jsxDEV as r } from "react/jsx-dev-runtime";
//#region lib/components/Button/ButtonIcon.tsx
var i = "/opt/render/project/src/shared-ui/lib/components/Button/ButtonIcon.tsx";
function a({ icon: n, borderRadius: a, ...s }) {
	let c = o(n, a, s.shape), l = [t["button-icon"], c];
	return /* @__PURE__ */ r(e, {
		className: l.join(" "),
		iconStart: n,
		...s
	}, void 0, !1, {
		fileName: i,
		lineNumber: 26,
		columnNumber: 12
	}, this);
}
function o(e, n, r) {
	if (n) return t[`border-radius-${n}`];
	if (r === "pill") return "";
	let i = s(e);
	return i && i >= 24 ? t["border-radius-12"] : t["border-radius-8"];
}
function s(e) {
	if (n(e) && typeof e.props == "object" && e.props !== null) return e.props.size;
}
//#endregion
export { a as ButtonIcon };
